// extracted by mini-css-extract-plugin
module.exports = {"PDF-viewer":"PDFViewer_PDF-viewer__S6Qnx","PDF-viewer__page-container":"PDFViewer_PDF-viewer__page-container__uexZg","PDF-viewer__page":"PDFViewer_PDF-viewer__page__1jkHC"};